<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>    
  <GlobalSnackbar />
  </v-app>
</template>

<script>
import GlobalSnackbar from "@/components/GlobalSnackbar"

export default {
  name: 'App',

  components: {GlobalSnackbar},
};
</script>
